export function parseJsonObject(value) {
  if (value && typeof value === "object" && !Array.isArray(value)) return value;
  if (typeof value !== "string" || !value.trim()) return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch (_) {
    return {};
  }
}

export function conditionContent(run) {
  const content = parseJsonObject(run && run.content);
  return {
    conditions: Array.isArray(content.conditions) ? content.conditions.map(String) : [],
    goal: typeof content.goal === "string" ? content.goal : "",
    rounds: Number.isFinite(Number(content.rounds)) ? Number(content.rounds) : null,
    judgeReason: typeof content.judgeReason === "string" ? content.judgeReason : "",
    error: typeof content.error === "string" ? content.error : null,
  };
}

export function resultText(run) {
  if (!run || run.passed == null) return "尚未判定";
  const passed = Boolean(Number(run.passed));
  if (run.score != null) return `${run.score} 分（${passed ? "通過" : "未通過"}）`;
  return passed ? "通過" : "未通過";
}

export function buildDuelExportRows(config, runs, detailsByRunId = {}) {
  const summaryRows = runs.map((run) => {
    const content = conditionContent(run);
    return {
      對戰名稱: config.name,
      學生: run.playerName,
      狀態: run.status,
      判定結果: resultText(run),
      分數: run.score,
      判定說明: content.judgeReason,
      錯誤: content.error,
      學生條件: content.conditions.join("\n"),
      目標: content.goal || config.goal,
      回合數: content.rounds == null ? config.rounds : content.rounds,
      建立時間: run.createdAt,
      RunId: run.runId,
    };
  });

  const transcriptRows = [];
  for (const run of runs) {
    const detail = detailsByRunId[run.runId] || {};
    const records = Array.isArray(detail.records) ? detail.records : [];
    records.forEach((record, index) => {
      transcriptRows.push({
        對戰名稱: config.name,
        學生: run.playerName,
        RunId: run.runId,
        順序: index + 1,
        時間: record.timestamp,
        發言者: record.chatName || record.character || "NPC",
        角色代碼: record.character,
        對話內容: record.chatContent,
        Token資訊: typeof record.tokenCal === "string" ? record.tokenCal : JSON.stringify(record.tokenCal ?? null),
      });
    });
  }
  return { summaryRows, transcriptRows };
}
